import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const warningBar = css`
  && {
    height: auto;
    min-height: 2.75rem;

    @media only screen and (max-width: ${dimensions.tabletMax}) {
      min-height: 4.5rem;
    }

    @media only screen and (max-width: ${dimensions.phoneLarge}) {
      min-height: 6.5rem;
    }

    & > div {
      height: auto;

      @media only screen and (max-width: ${dimensions.tabletMax}) {
        min-height: 4.5rem;
      }

      @media only screen and (max-width: ${dimensions.phoneLarge}) {
        min-height: 6.5rem;
      }
    }
  }
`;
